import { useRecoilState, useRecoilValue } from 'recoil';
import { userState } from '../../../states/userState';
import { constructions } from '../../../utils/variables/constructions';
import SelectBox from '../../uikit/atoms/selectboxes/SelectBox';
import TextInputForproductBno from '../../uikit/atoms/textfields/TextInputForProductBno';
import TextInputForProductNo from '../../uikit/atoms/textfields/TextInputForProductNo';
import SelectBoxForFactory from '../../uikit/molecules/selectboxes/SelectBoxForFactory';
import classes from './HeaderController.module.scss';
import React, { useEffect, useState } from 'react';
import { setUserToLocalStorage } from '../../../utils/functions/localStorageManager';
import { User } from '../../../types';
import SetWorkersButton from '../../uikit/atoms/buttons/SetWorkersButton';
import FromToDatePickers from '../../uikit/molecules/selectboxes/datePickers/FromToDatePickers';
import { FetchButton } from '../../uikit/atoms/buttons/FetchButton';
import { ExportButton } from '../../uikit/atoms/buttons/ExportButton';
import { useGetDiaryList } from '../../../hooks/api/posts/useGetDiraryList';
import { formatDate } from '../../../utils/functions/formatting';
import { diaryListState } from '../../../states/diaryListState';
import { Calendar, Dirary, processInfo } from '../../../types/dirary';
import { calendarListState } from '../../../states/calendarListState';
import { useGetMorimatsuCalendar } from '../../../hooks/api/calendar/useGetMorimatsuCalendar';
import { processListState } from '../../../states/processListState';
import { useGetProcessees } from '../../../hooks/api/processes/useGetProcesses';
import { fetchManageStateForList } from '../../../states/fetchMnageState';
import useCsvDownloader from '../../../hooks/util/useCsvDownloarder';
const HeaderController = () => {
  const { downloadCsv } = useCsvDownloader();
  //リコイル
  const fetchDiaryList = useRecoilValue(fetchManageStateForList);
  const [user, setUser] = useRecoilState<User>(userState);
  const [recoilDiaryList, setRecoilDiaryList] =
    useRecoilState<Dirary[]>(diaryListState);
  const [calendarList, setCalendarList] =
    useRecoilState<Calendar[]>(calendarListState);
  const [processList, setProcessList] =
    useRecoilState<processInfo[]>(processListState);
  //APIフェッチ-カスタムフック
  const { getProcessesFromDiaryList } = useGetProcessees();
  const { getIsHolidayList } = useGetMorimatsuCalendar();
  const { getDiaryListByAllParams } = useGetDiaryList();

  //製番2フォーカス移動時に入力値を保持するためのstate
  const [toggleBnoClear, setToggleBnoClear] = useState(false);
  const [productNo, setProductNo] = useState(
    user.initialParameters.productNo ?? ''
  );
  const [productBno, setProductBno] = useState(
    user.initialParameters.productBno ?? ''
  );
  const getEndOfMonth = (date: Date) => {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
    // return new Date();
  };
  const getStartOfMonth = (date: Date) => {
    return new Date(date.getFullYear(), date.getMonth() - 0, 1);
    // return new Date();
  };
  const getDaysAgo = (date: Date, days: number) => {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() - days);
    return newDate;
  };
  const today = new Date();

  const [fromDate, setFromdate] = useState<Date>(getDaysAgo(today, 15)), //日付From
    [toDate, setTodate] = useState<Date>(today); //日付To

  // const handleSelectConstruction = (e: number) => {
  //   const value = e;
  //   setUser((prevUser: User) => {
  //     const newUser: User = {
  //       ...prevUser,
  //       initialParameters: {
  //         ...prevUser.initialParameters,
  //         construction: value,
  //       },
  //     };
  //     setUserToLocalStorage(newUser);
  //     return newUser;
  //   });
  //   // console.log(e);
  // };
  const handleFetchButtonClick = async () => {
    const formatFromDate = formatDate(fromDate);
    const formatToDate = formatDate(toDate);
    //日報情報の取得
    const workerArray = user.initialParameters.workersForList
      ? user.initialParameters.workersForList.map((worker) => {
          return Number(worker.workerId);
        })
      : [];
    const diaryList = await getDiaryListByAllParams(
      user.initialParameters.productNo ?? '',
      user.initialParameters.productBno ?? '',
      workerArray,
      formatFromDate,
      formatToDate,
      user.initialParameters.factoryNo
      // user.initialParameters.construction
    );
    // console.log("DEBUG_GET_ARRAYLIST", diaryList);
    if (!diaryList || diaryList.length === 0) {
      setRecoilDiaryList([]);
      setCalendarList([]);
      setProcessList([]);
      return;
    }
    setRecoilDiaryList(diaryList);
    //稼働日カレンダーの取得（日付と稼働日のリスト）
    const calendarList = await getIsHolidayList(formatFromDate, formatToDate);
    setCalendarList(calendarList);
    // // 工程の取得
    const processList = await getProcessesFromDiaryList(diaryList);
    setProcessList(processList);
  };
  const handleExportButtonClick = () => {
    downloadCsv(recoilDiaryList, 'diary_list');
  };
  useEffect(() => {
    // if (recoilDiaryList.length === 0) {
    const fetchDiaryList = async () => {
      await handleFetchButtonClick();
    };
    fetchDiaryList();
    // }
  }, [fetchDiaryList]);

  return (
    <div className={classes.rootContainer}>
      <div className={classes.searchParams}>
        <div className={classes.factory}>
          <p>製作工場</p>
          <SelectBoxForFactory />
        </div>
        <div className={classes.productNoContainer}>
          <p>製作番号</p>
          <div>
            <div className={classes.ProductNo}>
              <TextInputForProductNo
                fullWidth={false}
                label={''}
                multiline={false}
                required={false}
                type={'number'}
                rows={1}
                disabled={false}
                // InputProps={true}
                placeholder={'01234567'}
                productNo={productNo}
                setProductNo={setProductNo}
                productBno={productBno}
                setProductBno={setProductBno}
                colorMode={'light'}
                setMode={'view'}
                setToggleBnoClear={setToggleBnoClear}
              />
            </div>
            <span className={classes.hyphen}>-</span>
            <div className={classes.ProductBNo}>
              <TextInputForproductBno
                fullWidth={false}
                label={''}
                multiline={false}
                required={false}
                type={'number'}
                rows={1}
                disabled={false}
                // InputProps={true}
                placeholder={'01'}
                productNo={productNo}
                setProductNo={setProductNo}
                productBno={productBno}
                setProductBno={setProductBno}
                colorMode={'light'}
                setMode={'view'}
                toggleBnoClear={toggleBnoClear}
              />
            </div>
          </div>
        </div>
        {/* <div className={classes.construction}>
          <p>工事区分</p>
          <div>
            <SelectBox
              label={"工事区分"}
              options={constructions}
              required={true}
              select={handleSelectConstruction}
              value={user.initialParameters.construction}
              disabled={false}
            />
          </div>
        </div> */}
        <div className={classes.workers}>
          <p>作業者</p>
          <SetWorkersButton />
        </div>
        <div className={classes.datePickers}>
          <div>
            <FromToDatePickers
              disabled={false}
              setFromdate={setFromdate}
              setTodate={setTodate}
              fromDate={fromDate}
              toDate={toDate}
              mode="flex"
              label={''}
            />
          </div>
        </div>
        <div className={classes.buttons}>
          <div className={classes.fetch}>
            <FetchButton
              disabled={false}
              onClick={handleFetchButtonClick}
              caption={'検索実行'}
            />
          </div>
          <div className={classes.export}>
            <ExportButton
              disabled={false}
              onClick={handleExportButtonClick}
              caption={'CSV出力'}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderController;
